import React from 'react';
import classNames from 'classnames';
import {Loader} from "@eika/loader";

interface Props {
    namespace?: string;
}

export default (props: Props): React.ReactElement => {
    return (
        <div className={classNames('spinner-wrapper', props.namespace)}>
            <Loader />
        </div>
    );
};
